import { DistanceType, CommandType } from '../types';

/**
 * 回避率を計算する（新計算式）
 * 計算式: 15 × 自Spe ÷ 相手Spe
 * 上限なし
 * @returns 回避率（%）
 */
export function calculateEvasionRate(defenderSpeed: number, attackerSpeed: number): number {
  if (attackerSpeed <= 0) return 0;
  return 15 * defenderSpeed / attackerSpeed;
}

/**
 * 必中判定（回避不可）かどうかを判定する
 * 近距離で双方が武器攻撃の場合のみ必中（回避不可の相打ち）
 */
export function isGuaranteedHit(
  distance: DistanceType,
  attackerCmd: CommandType,
  defenderCmd: CommandType
): boolean {
  return (
    distance === DistanceType.NEAR &&
    attackerCmd === CommandType.WEAPON_ATTACK &&
    defenderCmd === CommandType.WEAPON_ATTACK
  );
}
